import { AppLayout } from "../layouts/AppLayout";
import { SotdaOnboardingScreen } from "../redesign/live/OnboardingScreen";

// 가입 직후 온보딩 — /onboarding. 탭바 없는 풀스크린(가입 플로우)이라
// BottomNav 포함 TabLayout 대신 AppLayout만 사용.
// design doc: 2026-05-22-sotda-ia-restructure §4 Phase E
export function OnboardingPage() {
  return (
    <AppLayout>
      <SotdaOnboardingScreen />
    </AppLayout>
  );
}
